import { Route, Routes } from "react-router-dom";
import Cohorts from "./Cohorts";

export default function CohortsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Cohorts />} />
    </Routes>
  );
}
